import { District, DistrictService } from '@gbhem/api';
import { Column } from 'react-table';

import { Table } from '../../components';

const columns = [
  {
    Header: 'NAME',
    accessor: 'name',
    id: 'name',
    Cell: ({ value }) => value
  },
  {
    Header: 'CONFERENCE',
    accessor: 'conference',
    id: 'conference',
    Cell: ({ value }) => value.name
  }
] as Column<District>[];

export function Districts() {
  const initialPageSize = 10;
  const initialPageIndex = 0;

  return (
    <Table
      columns={columns}
      data={[]}
      pageIndex={initialPageIndex}
      pageSize={initialPageSize}
      count={0}
      loader={async (props) => {
        const quickSearch = await DistrictService.quickSearch(
          'District',
          props.size,
          props.page * props.size,
          ['conference'],
          props.isQuickSearch,
          props.orderBy,
          props.filters
        );

        return { data: quickSearch.data, count: quickSearch.count };
      }}
    />
  );
}

export default Districts;
